import axios from "axios";
import i18n from "../i18n/i18n";

const apiUrl = import.meta.env.VITE_API_URL;

const api = axios.create({
  baseURL: apiUrl,
});

// Add interceptor
api.interceptors.request.use((config) => {
  config.headers["Accept-Language"] = i18n.language || "en";
  return config;
});

export default api;
